export const VIDEO_START = "video_start";
export const VIDEO_PROGRESS = "video_progress";
export const VIDEO_COMPLETE = "video_complete";
export const PAGE_VIEW = "page_view";
export const SIGN_UP = "sign_up";
export const JOIN_GROUP = "join_group";
export const SEARCH = "search";